import { httpservice } from '../services';
import { constants } from '../constant/constant';
import { dateFormat } from '../helper/StringUtils';

export const deleteLicenseSubInstance = async (id) => {
  try {
    const response = await httpservice()
      .delete(`${constants.API.DELETE_LICENSE_SUB_INSTANCE}/${id}`);

    return {
      status: 1,
      data: response.data,
    };
  } catch (error) {
    return {
      status: 0,
      data: error.response && error.response.data ? error.response.data : error,
    };
  }
};

export const getSubInstances = (obj, clientObj) => async (dispatch) => {
  try {
    let query;

    if (clientObj) {
      query = `${constants.API.LICENSE_SUB_INSTANCES}/${clientObj.clientId}/${clientObj.softwareId}?page=${obj.page}&size=${obj.size}`;
    } else {
      query = `${constants.API.LICENSE_SUB_INSTANCES}/${obj.id}?page=${obj.page}&size=${obj.size}`;
    }

    dispatch({
      payload: [],
      type: 'GET_LICENSE_SUB_INSTANCES_REQUEST_INITIATED',
    });

    const instanceData = await httpservice()
      .get(query);

    const rows = instanceData.data.response.data.licenses;

    const count = instanceData.data.response.data.totalItems;

    const finalData = rows.map((data) => (
      {
        ...data,
        created_at: dateFormat(data.createdAt),
      }
    ));

    dispatch({
      payload: {
        data: finalData,
        count,
      },
      type: 'GET_LICENSE_SUB_INSTANCES_REQUEST_SUCCESS',
    });
  } catch (error) {
    dispatch({
      payload: error,
      type: 'GET_LICENSE_SUB_INSTANCES_REQUEST_ERROR',
    });
  }
};
